import React from 'react';

export const LazyUserApprovalListPage = React.lazy(() => import('./UserApprovalListPage'));
export const LazyAdministratorManagementListsPage = React.lazy(() => import('./UserList'));
export const LazyFrsManagementListsPage = React.lazy(() => import('./FrsList'));
export const LazyWorkerManagementListsPage = React.lazy(() => import('./WorkerList'));
